import { render, staticRenderFns } from "./NotificationsSettingsModal.vue?vue&type=template&id=3cff5af8&scoped=true&"
import script from "./NotificationsSettingsModal.vue?vue&type=script&lang=js&"
export * from "./NotificationsSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsSettingsModal.vue?vue&type=style&index=0&id=3cff5af8&scoped=true&lang=scss&"
import style1 from "./NotificationsSettingsModal.vue?vue&type=style&index=1&id=3cff5af8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cff5af8",
  null
  
)

export default component.exports